import { uniq } from 'lodash';
import { FormInstance } from 'ssc-ui-react/typings/components/form/types';

import { createSelectors } from '@/store/constructor/createSelectors';
import { createStore } from '@/store/constructor/createStore';

import { getWorkstationPerformanceLastTenHours, GetWorkstationPerformanceLastTenHoursParams } from '../api';
import { MAX_SELECTED_WORKSTATION } from '../const';
import { TargetItem, ThroughputItem } from '../defined';

type State = {
  loading: boolean;
  throughputItems: ThroughputItem[];
  targetItems: TargetItem[];
  form?: FormInstance;
};

type Action = {
  getWorkstationPerformanceLastTenHoursAsync: (params: GetWorkstationPerformanceLastTenHoursParams) => Promise<void>;
  setForm: (form?: FormInstance) => void;
  getForm: () => FormInstance | undefined;
};

const useLastTenHoursWorkstationPerformanceStore = createSelectors(
  createStore<State & Action>((set, get) => {
    return {
      loading: false,
      form: undefined,
      throughputItems: [],
      targetItems: [],
      setForm: (form) => set({ form }),
      getForm: () => get().form,
      getWorkstationPerformanceLastTenHoursAsync: async (params) => {
        try {
          set({ loading: true });
          const defaultParams = {
            biz_workstation_id_list: get().form?.getFieldValue('biz_workstation_id_list'),
          };
          const res = await getWorkstationPerformanceLastTenHours({ ...defaultParams, ...params });
          const selectedWorkstation = uniq(res.data?.throughput_items
            ?.map(item => item.workstation)
            ?.filter(Boolean)
          )?.slice(0, MAX_SELECTED_WORKSTATION) || [];
          set({
            throughputItems: res.data?.throughput_items || [],
            targetItems: res.data?.target_items || [],
          });
        } catch (error) {
          console.error(error);
        } finally {
          set({ loading: false });
        }
      },
    };
  }),
);

export default useLastTenHoursWorkstationPerformanceStore;
